export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const isChrome = navigator.userAgent.indexOf("Chrome") !== -1;
